import CanvasController from './canvas-controller.js';
import { palette } from '../color.js';
import { presetSignals, computeSpectrogram } from '../chirp-things.js';

export default class CrossingChirpsController extends CanvasController {

    constructor(id, width, height) {
        super(id, width, height);
        
        this.signal = presetSignals.crossingChirps(256);
        this.spectrogram = computeSpectrogram(this.signal, 32, 4);
        
        this.animAmt = 0;
        this.colormap = this.generateColormap();
    }

    generateColormap() {
        const colors = [];
        for (let i = 0; i < 256; i++) {
            const t = i / 255;
            const r = Math.floor(20 + 235 * Math.pow(t, 0.8));
            const g = Math.floor(20 + 100 * t);
            const b = Math.floor(80 - 60 * t);
            colors.push(`rgb(${r},${g},${b})`);
        }
        return colors;
    }

    update(dt, mousePosition) {
        this.animAmt += dt / 6;
        this.animAmt %= 1;
    }

    render() {
        this.clear();
        this.context.save();
        
        this.renderSpectrogram();
        this.renderChirpLines();
        this.renderTimeMarker();
        
        this.context.restore();
    }

    renderSpectrogram() {
        const margin = 30;
        const spectroWidth = this.canvas.width - 2 * margin;
        const spectroHeight = this.canvas.height - 2 * margin;
        
        const numTimeSteps = this.spectrogram.length;
        const numFreqBins = this.spectrogram[0].length;
        
        const cellWidth = spectroWidth / numTimeSteps;
        const cellHeight = spectroHeight / numFreqBins;
        
        let maxVal = 0;
        for (const row of this.spectrogram) {
            for (const val of row) {
                if (val > maxVal) maxVal = val;
            }
        }
        if (maxVal === 0) maxVal = 1;
        
        for (let t = 0; t < numTimeSteps; t++) {
            for (let f = 0; f < numFreqBins; f++) {
                const val = this.spectrogram[t][f] / maxVal;
                const colorIdx = Math.min(255, Math.floor(val * 255 * 2.5));
                
                this.context.fillStyle = this.colormap[colorIdx];
                this.context.fillRect(
                    margin + t * cellWidth,
                    margin + (numFreqBins - 1 - f) * cellHeight,
                    cellWidth + 1,
                    cellHeight + 1
                );
            }
        }
    }

    renderChirpLines() {
        const margin = 30;
        const spectroWidth = this.canvas.width - 2 * margin;
        const spectroHeight = this.canvas.height - 2 * margin;
        
        this.context.setLineDash([5, 5]);
        this.context.lineWidth = 2;
        
        this.context.strokeStyle = '#4af';
        this.context.globalAlpha = 0.7;
        this.context.beginPath();
        this.context.moveTo(margin, margin + spectroHeight * 0.85);
        this.context.lineTo(margin + spectroWidth, margin + spectroHeight * 0.15);
        this.context.stroke();
        
        this.context.strokeStyle = '#f4a';
        this.context.beginPath();
        this.context.moveTo(margin, margin + spectroHeight * 0.15);
        this.context.lineTo(margin + spectroWidth, margin + spectroHeight * 0.85);
        this.context.stroke();
        
        this.context.globalAlpha = 1;
        this.context.setLineDash([]);
    }

    renderTimeMarker() {
        const margin = 30;
        const spectroWidth = this.canvas.width - 2 * margin;
        const spectroHeight = this.canvas.height - 2 * margin;
        
        const markerX = margin + this.animAmt * spectroWidth;
        
        this.context.strokeStyle = '#fff';
        this.context.lineWidth = 2;
        this.context.globalAlpha = 0.8;
        this.context.beginPath();
        this.context.moveTo(markerX, margin);
        this.context.lineTo(markerX, margin + spectroHeight);
        this.context.stroke();
        this.context.globalAlpha = 1;
    }
}
